<template>
  <transition name="fade">
    <div
        v-if="visible"
        class="message-modal"
        @click.self="close"
    >
      <div class="message-panel">
        <!-- 标题栏 -->
        <div class="panel-header">
          <h3>未处理消息</h3>
          <span class="close" @click="close">×</span>
        </div>

        <!-- 消息列表 -->
        <div class="message-list">
          <div
              v-for="msg in messages"
              :key="msg.id"
              class="message-item"
              :class="getMessageClass(msg.messageType)"
              @click="handleMessage(msg)"
          >
            <div class="message-avatar">
              <img :src="msg.avatar || defaultAvatar">
            </div>
            <div class="message-content">
              <div class="message-title">
                <span class="message-type-tag">{{ getTypeName(msg.messageType) }}</span>
                {{ msg.nickname }}
              </div>
              <div class="message-desc" v-if="msg.messageType==1">{{ msg.msgContent }}</div> <!-- 公告 -->
              <div class="message-desc" v-if="msg.messageType==3">{{ msg.msgContent }}</div> <!-- 交换名片回复  -->
              <!-- 交换名片专用布局 -->
              <div v-if="msg.messageType == 2" class="card-exchange-content">
                <div class="card-info">
                  <div class="info-row">
                    <van-icon name="friends-o" class="info-icon" />
                    <span class="info-label">公司：</span>
                    <span class="info-value">{{ msgObj(msg.msgContent).company }}</span>
                  </div>
                  <div class="info-row">
                    <van-icon name="user-o" class="info-icon" />
                    <span class="info-label">职位：</span>
                    <span class="info-value">{{ msgObj(msg.msgContent).position }}</span>
                  </div>
                </div>

                <div class="card-actions">
                  <van-button
                      size="small"
                      type="primary"
                      plain
                      @click.stop="handleCardAction(msg.id, 'accept')"
                  >
                    同意交换
                  </van-button>
                  <van-button
                      size="small"
                      @click.stop="handleCardAction(msg.id, 'reject')"
                  >
                    拒绝
                  </van-button>
                </div>
              </div>
              <div class="message-time">{{ formatTime(msg.createTime) }}</div>
            </div>
            <button
                v-if="msg.canDelete"
                class="delete-btn"
                @click.stop="deleteMessage(msg.id)"
            >
              删除
            </button>
          </div>

          <div v-if="messages.length === 0" class="empty">
            <img src="@/assets/icons/icon_no_data.png">
            <p>暂无未读消息</p>
          </div>
        </div>

        <div class="panel-footer">
          <button
              class="clear-all"
              :disabled="messages.length === 0"
              @click="clearAll"
          >
            一键清除
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { defaultAvatar } from "@/utils/constant";
import {mapGetters} from "vuex";
import {Button, Dialog, Icon, Toast} from "vant";

// 消息类型配置
const MESSAGE_TYPES = {
  1: { name: '公告', class: 'notice', color: '#07C160', icon: '📢' },
  2: { name: '交换名片', class: 'card-exchange', color: '#1989FA', icon: '👤' },
  3: { name: '交换名片回复', class: 'card-reply', color: '#1989FA', icon: '↩️' },
  4: { name: '系统警告', class: 'system-warning', color: '#FF4D4F', icon: '⚠️' },
  5: { name: '资源评价', class: 'resource-review', color: '#FF9500', icon: '⭐' },
  6: { name: '奖励到账', class: 'reward', color: '#FFC300', icon: '💰' },
  7: { name: '红包退回', class: 'refund', color: '#FF4D4F', icon: '🔄' }
};

export default {
  name: 'EnhancedMessagePopup',
  props: {
    show: Boolean,
    initialMessages: {
      type: Array,
      default: () => []
    }
  },
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon
  },
  computed:{
    ...mapGetters(["live"]),
  },
  data() {
    return {
      visible: this.show,
      messages: [...this.initialMessages],
      defaultAvatar: defaultAvatar
    };
  },
  watch: {
    show(newVal) {
      this.visible = newVal;
      if(newVal){
        this.queryList();
      }
    },
    initialMessages: {
      immediate: true,
      handler(val) {
        this.messages = [...val];
      }
    }
  },
  methods: {
    handleCardAction(id,isAgree){
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "处理中...",
      });
      this.$http.get(`/card/response?messageId=${id}&isAgree=${isAgree}`).then(res=>{
        this.$toast.success("已处理");
        this.queryList();
      }).finally(()=>{
        toast.clear();
      })
    },
    msgObj(msgContext) {
      return JSON.parse(msgContext)
    },
    queryList(){
      this.$http.get(`/message/queryUnReadLiveMsg?liveId=${this.live.id}`).then(res=>{
        this.messages = res.data;
        this.$Bus.$emit("refreshNotice");
      })
    },
    // 获取消息类型名称
    getTypeName(type) {
      return MESSAGE_TYPES[type]?.name || '消息';
    },

    // 获取消息样式类
    getMessageClass(type) {
      return `type-${MESSAGE_TYPES[type]?.class || 'default'}`;
    },

    // 关闭弹窗
    close() {
      this.visible = false;
      this.$emit('update:show', false);
    },

    // 处理消息点击
    handleMessage(msg) {
      msg.isRead = true;
      this.$emit('message-click', msg);
      this.close();
    },

    // 删除消息
    deleteMessage(id) {
      // this.messages = this.messages.filter(m => m.id !== id);
      this.$http.get(`/message/clearMsgById?messageId=${id}`).then(()=>{
        this.queryList();
      });
    },

    // 清除所有
    clearAll() {
      Dialog.confirm({
        title: '确认清除所有消息？',
        message: '清除所有可清除消息',
      }).then(() => {
        return this.$http.get(`/message/clearLiveMsg?liveId=${this.live.id}`);
      }).then(()=>{
        this.queryList();
      }).catch(err=>{
        console.log('取消'+err);
      })
    },

    // 格式化时间（放大字体版）
    formatTime(timestamp) {
      const now = new Date();
      const date = new Date(timestamp);
      const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));

      if (diffDays === 0) {
        return '今天 ' + date.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });
      } else if (diffDays === 1) {
        return '昨天 ' + date.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });
      } else {
        return `${date.getMonth()+1}月${date.getDate()}日`;
      }
    }
  }
};
</script>

<style lang="less" scoped>
/* 基础字体大小 */
@base-font-size: 8px; /* 原16px */

/* 蒙层样式 */
.message-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  font-size: @base-font-size * 1.5;
}

.message-panel {
  width: 100%;
  max-height: 70vh;
  background: white;
  border-radius: 8px 8px 0 0; /* 原16px */
  display: flex;
  flex-direction: column;
}

/* 标题栏 */
.panel-header {
  padding: 12px; /* 原24px */
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;

  h3 {
    margin: 0;
    font-size: 1.2em; /* 约14.4px */
    color: #333;
    font-weight: bold;
  }

  .close {
    font-size: 1.5em; /* 约18px */
    color: #999;
    padding: 6px; /* 原12px */
  }
}

/* 消息列表 */
.message-list {
  flex: 1;
  overflow-y: auto;
  padding: 0 12px; /* 原24px */
  -webkit-overflow-scrolling: touch;
}

.message-item {
  padding: 9px 0; /* 原18px */
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f5f5f5;

  &:last-child {
    border-bottom: none;
  }

  /* 通用消息样式 */
  &.type-default {
    border-left: 2px solid #ccc; /* 原4px */
    padding-left: 10px; /* 原20px */
  }

  /* 公告 */
  &.type-notice {
    border-left: 2px solid #07C160;
    padding-left: 10px;
    .message-type-tag {
      background: #07C160;
    }
  }

  /* 交换名片 */
  &.type-card-exchange {
    border-left: 2px solid #1989FA;
    padding-left: 10px;
    .message-type-tag {
      background: #1989FA;
    }
    .card-exchange-content {
      margin-top: 6px; /* 原12px */
      border-top: 1px dashed #ebedf0;
      padding-top: 6px;
    }

    .card-info {
      background: #f7f9ff;
      border-radius: 4px; /* 原8px */
      padding: 6px; /* 原12px */
      margin-bottom: 6px; /* 原12px */

      .info-row {
        display: flex;
        align-items: center;
        margin-bottom: 4px; /* 原8px */
        font-size: 0.9em;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .info-icon {
        margin-right: 4px; /* 原8px */
        color: #1989fa;
        font-size: 1.1em;
      }

      .info-label {
        color: #666;
        min-width: 30px; /* 原40px */
      }

      .info-value {
        color: #333;
        font-weight: 500;
        flex: 1;
      }
    }

    .card-actions {
      display: flex;
      justify-content: flex-end;
      gap: 4px; /* 原8px */
      margin-top: 4px; /* 原8px */

      .van-button {
        min-width: 35px; /* 原70px */
        height: 14px; /* 原28px */
        line-height: 13px; /* 原26px */
        padding: 0 4px; /* 原8px */
        font-size: 0.8em;
      }
    }
  }

  /* 其他类型样式... */
}

.message-avatar {
  width: 30px; /* 原60px */
  height: 30px; /* 原60px */
  margin-right: 9px; /* 原18px */

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
}

.message-content {
  flex: 1;
  min-width: 0;
}

.message-title {
  font-size: 1em; /* 约12px */
  color: #333;
  margin-bottom: 3px; /* 原6px */
  display: flex;
  align-items: center;
}

.message-type-tag {
  display: inline-block;
  padding: 1px 4px; /* 原2px 8px */
  margin-right: 4px; /* 原8px */
  border-radius: 2px; /* 原4px */
  color: white;
  font-size: 0.8em;
}

.message-desc {
  font-size: 0.9em;
  color: #666;
  margin-bottom: 3px; /* 原6px */
  line-height: 1.4;
}

.message-time {
  font-size: 0.8em;
  color: #999;
}

.delete-btn {
  padding: 3px 6px; /* 原6px 12px */
  font-size: 0.9em;
  color: #ff4d4f;
  background: none;
  border: 1px solid #ff4d4f;
  border-radius: 9px; /* 原18px */
  margin-left: 6px; /* 原12px */
}

.empty {
  padding: 30px 0; /* 原60px */
  text-align: center;

  img {
    width: 75px; /* 原150px */
    opacity: 0.5;
  }

  p {
    margin-top: 9px; /* 原18px */
    color: #999;
    font-size: 1em;
  }
}

.panel-footer {
  padding: 9px 12px; /* 原18px 24px */
  border-top: 1px solid #f0f0f0;

  .clear-all {
    width: 100%;
    padding: 7px; /* 原15px */
    background: #f5f5f5;
    border: none;
    border-radius: 15px; /* 原30px */
    color: #666;
    font-size: 1em;

    &:disabled {
      opacity: 0.5;
    }

    &:not(:disabled):hover {
      background: #07C160;
      color: white;
    }
  }
}

/* 动画效果 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active {
  animation: slide-up 0.3s;
}
.slide-up-leave-active {
  animation: slide-up 0.3s reverse;
}
@keyframes slide-up {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

/* 响应式调整 */
@media (max-width: 480px) {
  .type-card-exchange {
    .card-actions {
      gap: 3px; /* 原6px */

      .van-button {
        min-width: 30px; /* 原60px */
        height: 13px; /* 原26px */
        line-height: 12px; /* 原24px */
      }
    }
  }
}
</style>
